import {
  SELECT_ADMIN_TAB,
  FETCH_ADMIN_DATA_REQUEST,
  FETCH_ADMIN_DATA_SUCCESS,
  FETCH_ADMIN_DATA_FAILURE,
  FETCH_ADMIN_REPORT_CATEGORY_DATA_REQUEST,
  FETCH_ADMIN_REPORT_CATEGORY_DATA_SUCCESS,
  FETCH_ADMIN_REPORT_CATEGORY_DATA_FAILURE,
  EDIT_ADMIN_REPORT_DATA_REQUEST,
  EDIT_ADMIN_REPORT_DATA_SUCCESS,
  EDIT_ADMIN_REPORT_DATA_FAILURE,
  SAVE_CATEGORY_ADMIN_REQUEST,
  SAVE_CATEGORY_ADMIN_SUCCESS,
  SAVE_CATEGORY_ADMIN_FAILURE,
  EDIT_CATEGORY_ADMIN_REQUEST,
  EDIT_CATEGORY_ADMIN_SUCCESS,
  EDIT_CATEGORY_ADMIN_FAILURE,
  DELETE_CATEGORY_ADMIN_REQUEST,
  DELETE_CATEGORY_ADMIN_SUCCESS,
  DELETE_CATEGORY_ADMIN_FAILURE,
  UPLOAD_USER_GUIDE_REQUEST,
  UPLOAD_USER_GUIDE_SUCCESS,
  UPLOAD_USER_GUIDE_FAILURE,
  DOWNLOAD_USER_GUIDE_REQUEST,
  DOWNLOAD_USER_GUIDE_SUCCESS,
  DOWNLOAD_USER_GUIDE_FAILURE,
  SAVE_GLOBAL_SELECTION_IMPC_REQUEST,
  SAVE_GLOBAL_SELECTION_IMPC_SUCCESS,
  SAVE_GLOBAL_SELECTION_IMPC_FAILURE,
  SAVE_GLOBAL_SELECTION_OPERATOR_REQUEST,
  SAVE_GLOBAL_SELECTION_OPERATOR_SUCCESS,
  SAVE_GLOBAL_SELECTION_OPERATOR_FAILURE,
  SAVE_GLOBAL_SELECTION_UNLOCODE_REQUEST,
  SAVE_GLOBAL_SELECTION_UNLOCODE_SUCCESS,
  SAVE_GLOBAL_SELECTION_UNLOCODE_FAILURE,
  SAVE_GLOBAL_SELECTION_MAILBOX_REQUEST,
  SAVE_GLOBAL_SELECTION_MAILBOX_SUCCESS,
  SAVE_GLOBAL_SELECTION_MAILBOX_FAILURE,
  SAVE_GLOBAL_SELECTION_PRODUCT_REQUEST,
  SAVE_GLOBAL_SELECTION_PRODUCT_SUCCESS,
  SAVE_GLOBAL_SELECTION_PRODUCT_FAILURE,
  SAVE_GLOBAL_SELECTION_MRDIMPC_REQUEST,
  SAVE_GLOBAL_SELECTION_MRDIMPC_SUCCESS,
  SAVE_GLOBAL_SELECTION_MRDIMPC_FAILURE,
  DELETE_GLOBAL_SELECTION_IMPC_REQUEST,
  DELETE_GLOBAL_SELECTION_IMPC_SUCCESS,
  DELETE_GLOBAL_SELECTION_IMPC_FAILURE,
  DELETE_GLOBAL_SELECTION_OPERATOR_REQUEST,
  DELETE_GLOBAL_SELECTION_OPERATOR_SUCCESS,
  DELETE_GLOBAL_SELECTION_OPERATOR_FAILURE,
  DELETE_GLOBAL_SELECTION_UNLOCODE_REQUEST,
  DELETE_GLOBAL_SELECTION_UNLOCODE_SUCCESS,
  DELETE_GLOBAL_SELECTION_UNLOCODE_FAILURE,
  DELETE_GLOBAL_SELECTION_MAILBOX_REQUEST,
  DELETE_GLOBAL_SELECTION_MAILBOX_SUCCESS,
  DELETE_GLOBAL_SELECTION_MAILBOX_FAILURE,
  DELETE_GLOBAL_SELECTION_PRODUCT_REQUEST,
  DELETE_GLOBAL_SELECTION_PRODUCT_SUCCESS,
  DELETE_GLOBAL_SELECTION_PRODUCT_FAILURE,
  DELETE_GLOBAL_SELECTION_MRDIMPC_REQUEST,
  DELETE_GLOBAL_SELECTION_MRDIMPC_SUCCESS,
  DELETE_GLOBAL_SELECTION_MRDIMPC_FAILURE,
  SET_TAB_STATUS,
} from './types/AdminDashboardActionTypes';

export function selectAdminTabActionCreator(activeTab) {
  return {
    type: SELECT_ADMIN_TAB,
    activeTab,
  };
}

export function fetchAdminReportDefinitionsRequestActionCreator() {
  return {
    type: FETCH_ADMIN_DATA_REQUEST,
  };
}

export function fetchAdminReportDataSuccessActionCreator(adminReports) {
  return {
    type: FETCH_ADMIN_DATA_SUCCESS,
    payload: {
      adminReports,
    },
  };
}

export function fetchAdminReportDataFailureActionCreator(error) {
  return {
    type: FETCH_ADMIN_DATA_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchAdminReportCategoryRequestActionCreator() {
  return {
    type: FETCH_ADMIN_REPORT_CATEGORY_DATA_REQUEST,
  };
}

export function fetchAdminReportCategorySuccessActionCreator(category) {
  return {
    type: FETCH_ADMIN_REPORT_CATEGORY_DATA_SUCCESS,
    payload: {
      category,
    },
  };
}

export function fetchAdminReportCategoryFailureActionCreator(error) {
  return {
    type: FETCH_ADMIN_REPORT_CATEGORY_DATA_FAILURE,
    payload: error,
    error: true,
  };
}

export function editAdminReportRequestActionCreator(reportCode, object) {
  return {
    type: EDIT_ADMIN_REPORT_DATA_REQUEST,
    payload: {
      reportCode,
      object,
    },
  };
}

export function editAdminReportSuccessActionCreator(payload) {
  return {
    type: EDIT_ADMIN_REPORT_DATA_SUCCESS,
    payload,
  };
}

export function editAdminReportFailureActionCreator(error) {
  return {
    type: EDIT_ADMIN_REPORT_DATA_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveCategoryAdminRequestActionCreator(object) {
  return {
    type: SAVE_CATEGORY_ADMIN_REQUEST,
    payload: {
      object,
    },
  };
}

export function saveCategoryAdminSuccessActionCreator(payload) {
  return {
    type: SAVE_CATEGORY_ADMIN_SUCCESS,
    payload,
  };
}

export function saveCategoryAdminFailureActionCreator(error) {
  return {
    type: SAVE_CATEGORY_ADMIN_FAILURE,
    payload: error,
    error: true,
  };
}

export function editCategoryAdminRequestActionCreator(categoryName, object) {
  return {
    type: EDIT_CATEGORY_ADMIN_REQUEST,
    payload: {
      categoryName,
      object,
    },
  };
}

export function editCategoryAdminSuccessActionCreator(payload) {
  return {
    type: EDIT_CATEGORY_ADMIN_SUCCESS,
    payload,
  };
}

export function editCategoryAdminFailureActionCreator(error) {
  return {
    type: EDIT_CATEGORY_ADMIN_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteCategoryAdminRequestActionCreator(categoryName) {
  return {
    type: DELETE_CATEGORY_ADMIN_REQUEST,
    payload: {
      categoryName,
    },
  };
}

export function deleteCategoryAdminSuccessActionCreator(payload) {
  return {
    type: DELETE_CATEGORY_ADMIN_SUCCESS,
    payload,
  };
}

export function deleteCategoryAdminFailureActionCreator(error) {
  return {
    type: DELETE_CATEGORY_ADMIN_FAILURE,
    payload: error,
    error: true,
  };
}

export function uploadUserGuideRequestActionCreator(payload) {
  return {
    type: UPLOAD_USER_GUIDE_REQUEST,
    payload,
  };
}

export function uploadUserGuideSuccessActionCreator(payload) {
  return {
    type: UPLOAD_USER_GUIDE_SUCCESS,
    payload,
  };
}

export function uploadUserGuideFailureActionCreator(error) {
  return {
    type: UPLOAD_USER_GUIDE_FAILURE,
    error,
  };
}

export function downloadUserGuideRequestActionCreator(payload) {
  return {
    type: DOWNLOAD_USER_GUIDE_REQUEST,
    payload,
  };
}

export function downloadUserGuideSuccessActionCreator(file, filename) {
  return {
    type: DOWNLOAD_USER_GUIDE_SUCCESS,
    payload: {
      file,
      filename,
    },
  };
}

export function downloadUserGuideFailureActionCreator(error) {
  return {
    type: DOWNLOAD_USER_GUIDE_FAILURE,
    error,
  };
}

export function saveGlobalSelectionImpcRequestActionCreator(selectionName, direction, postalOperatorType, selectedIMPCCodes) {
  return {
    type: SAVE_GLOBAL_SELECTION_IMPC_REQUEST,
    payload: {
      selectionName,
      direction,
      postalOperatorType,
      selectedIMPCCodes,
    },
  };
}

export function saveGlobalSelectionImpcSuccessActionCreator(payload) {
  return {
    type: SAVE_GLOBAL_SELECTION_IMPC_SUCCESS,
    payload,
  };
}

export function saveGlobalSelectionImpcFailureActionCreator(error) {
  return {
    type: SAVE_GLOBAL_SELECTION_IMPC_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteGlobalSelectionImpcRequestActionCreator(selectionName) {
  return {
    type: DELETE_GLOBAL_SELECTION_IMPC_REQUEST,
    payload: selectionName,
  };
}

export function deleteGlobalSelectionImpcSuccessActionCreator(payload) {
  return {
    type: DELETE_GLOBAL_SELECTION_IMPC_SUCCESS,
    payload,
  };
}

export function deleteGlobalSelectionImpcFailureActionCreator(error) {
  return {
    type: DELETE_GLOBAL_SELECTION_IMPC_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveGlobalSelectionOperatorRequestActionCreator(selectionName, direction, postalOperatorType, selectedIMPCCodes) {
  return {
    type: SAVE_GLOBAL_SELECTION_OPERATOR_REQUEST,
    payload: {
      selectionName,
      direction,
      postalOperatorType,
      selectedIMPCCodes,
    },
  };
}

export function saveGlobalSelectionOperatorSuccessActionCreator(payload) {
  return {
    type: SAVE_GLOBAL_SELECTION_OPERATOR_SUCCESS,
    payload,
  };
}

export function saveGlobalSelectionOperatorFailureActionCreator(error) {
  return {
    type: SAVE_GLOBAL_SELECTION_OPERATOR_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteGlobalSelectionOperatorRequestActionCreator(selectionName) {
  return {
    type: DELETE_GLOBAL_SELECTION_OPERATOR_REQUEST,
    payload: selectionName,
  };
}

export function deleteGlobalSelectionOperatorSuccessActionCreator(payload) {
  return {
    type: DELETE_GLOBAL_SELECTION_OPERATOR_SUCCESS,
    payload,
  };
}

export function deleteGlobalSelectionOperatorFailureActionCreator(error) {
  return {
    type: DELETE_GLOBAL_SELECTION_OPERATOR_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveGlobalSelectionUnlocodeRequestActionCreator(selectionName, direction, postalOperatorType, selectedUnlocodes) {
  return {
    type: SAVE_GLOBAL_SELECTION_UNLOCODE_REQUEST,
    payload: {
      selectionName,
      direction,
      postalOperatorType,
      selectedUnlocodes,
    },
  };
}

export function saveGlobalSelectionUnlocodeSuccessActionCreator(payload) {
  return {
    type: SAVE_GLOBAL_SELECTION_UNLOCODE_SUCCESS,
    payload,
  };
}

export function saveGlobalSelectionUnlocodeFailureActionCreator(error) {
  return {
    type: SAVE_GLOBAL_SELECTION_UNLOCODE_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteGlobalSelectionUnlocodeRequestActionCreator(selectionName) {
  return {
    type: DELETE_GLOBAL_SELECTION_UNLOCODE_REQUEST,
    payload: selectionName,
  };
}

export function deleteGlobalSelectionUnlocodeSuccessActionCreator(payload) {
  return {
    type: DELETE_GLOBAL_SELECTION_UNLOCODE_SUCCESS,
    payload,
  };
}

export function deleteGlobalSelectionUnlocodeFailureActionCreator(error) {
  return {
    type: DELETE_GLOBAL_SELECTION_UNLOCODE_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveGlobalSelectionMailboxRequestActionCreator(selectionName, direction, postalOperatorType, selectedEdiMailboxes) {
  return {
    type: SAVE_GLOBAL_SELECTION_MAILBOX_REQUEST,
    payload: {
      selectionName,
      direction,
      postalOperatorType,
      selectedEdiMailboxes,
    },
  };
}

export function saveGlobalSelectionMailboxSuccessActionCreator(payload) {
  return {
    type: SAVE_GLOBAL_SELECTION_MAILBOX_SUCCESS,
    payload,
  };
}

export function saveGlobalSelectionMailboxFailureActionCreator(error) {
  return {
    type: SAVE_GLOBAL_SELECTION_MAILBOX_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteGlobalSelectionMailboxRequestActionCreator(selectionName) {
  return {
    type: DELETE_GLOBAL_SELECTION_MAILBOX_REQUEST,
    payload: selectionName,
  };
}

export function deleteGlobalSelectionMailboxSuccessActionCreator(payload) {
  return {
    type: DELETE_GLOBAL_SELECTION_MAILBOX_SUCCESS,
    payload,
  };
}

export function deleteGlobalSelectionMailboxFailureActionCreator(error) {
  return {
    type: DELETE_GLOBAL_SELECTION_MAILBOX_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveGlobalSelectionProductRequestActionCreator(selectionName, selectedProducts) {
  return {
    type: SAVE_GLOBAL_SELECTION_PRODUCT_REQUEST,
    payload: {
      selectionName,
      selectedProducts,
    },
  };
}

export function saveGlobalSelectionProductSuccessActionCreator(payload) {
  return {
    type: SAVE_GLOBAL_SELECTION_PRODUCT_SUCCESS,
    payload,
  };
}

export function saveGlobalSelectionProductFailureActionCreator(error) {
  return {
    type: SAVE_GLOBAL_SELECTION_PRODUCT_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteGlobalSelectionProductRequestActionCreator(selectionName) {
  return {
    type: DELETE_GLOBAL_SELECTION_PRODUCT_REQUEST,
    payload: selectionName,
  };
}

export function deleteGlobalSelectionProductSuccessActionCreator(payload) {
  return {
    type: DELETE_GLOBAL_SELECTION_PRODUCT_SUCCESS,
    payload,
  };
}

export function deleteGlobalSelectionProductFailureActionCreator(error) {
  return {
    type: DELETE_GLOBAL_SELECTION_PRODUCT_FAILURE,
    payload: error,
    error: true,
  };
}

export function saveGlobalSelectionMrdImpcRequestActionCreator(selectionName, selectedIMPCCodes) {
  return {
    type: SAVE_GLOBAL_SELECTION_MRDIMPC_REQUEST,
    payload: {
      selectionName,
      selectedIMPCCodes,
    },
  };
}

export function saveGlobalSelectionMrdImpcSuccessActionCreator(payload) {
  return {
    type: SAVE_GLOBAL_SELECTION_MRDIMPC_SUCCESS,
    payload,
  };
}

export function saveGlobalSelectionMrdImpcFailureActionCreator(error) {
  return {
    type: SAVE_GLOBAL_SELECTION_MRDIMPC_FAILURE,
    payload: error,
    error: true,
  };
}

export function deleteGlobalSelectionMrdImpcRequestActionCreator(selectionName) {
  return {
    type: DELETE_GLOBAL_SELECTION_MRDIMPC_REQUEST,
    payload: selectionName,
  };
}

export function deleteGlobalSelectionMrdImpcSuccessActionCreator(payload) {
  return {
    type: DELETE_GLOBAL_SELECTION_MRDIMPC_SUCCESS,
    payload,
  };
}

export function deleteGlobalSelectionMrdImpcFailureActionCreator(error) {
  return {
    type: DELETE_GLOBAL_SELECTION_MRDIMPC_FAILURE,
    payload: error,
    error: true,
  };
}

export function setTabButtonStatus(status) {
  return {
    type: SET_TAB_STATUS,
    status,
  };
}
